import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBoardEmbedRoute: InvariantJiraRoute = {
	name: 'rapidboard-board-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed',
};
